import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

const cookieDomain = import.meta.env.VITE_COOKIE_DOMAIN ?? "eventsquare.io";

i18n
  // i18next-http-backend
  // loads translations from your server
  // https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    supportedLngs: ["en", "nl", "fr", "sv"],
    fallbackLng: "nl",
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    detection: {
      order: ["htmlTag", "cookie", "navigator"],
      lookupCookie: "_esq_lang",
      cookieDomain: cookieDomain,
      caches: ["cookie"],
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
